import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import Rem from "./lib/rem";
Rem();

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

const ipCallback = () => {
  if (window.returnCitySN) {
    // const city = window.returnCitySN["cname"];
  }
};
let el = document.getElementById("ipagent");
if (!el) {
  el = document.createElement("script");
  el.setAttribute("id", "ipagent");
  el.setAttribute("src", "//pv.sohu.com/cityjson?ie=utf-8");
  el.onload = () => {
    ipCallback();
  };
  document.body.appendChild(el);
} else {
  ipCallback();
}
